import SettingsVM from './settings-vm';
export default {
  prepUI: function() {
    //TODO
  },
  init: function() {
    ko.applyBindingsWithValidation(new SettingsVM(), document.getElementById('js-admin-billing-settings'), Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS);
  }
};

